import { ExperiencesService } from './../../experiences.service';
import { Component, OnInit, Input } from '@angular/core';
import { DVFormGroup } from 'src/app/shared/helpers/dynamic-validators/dynamic-validator';
import { IDropdownSettings } from 'ng-multiselect-dropdown';

@Component({
  selector: 'app-experience-basic-info',
  templateUrl: './experience-basic-info.component.html',
  styleUrls: ['./experience-basic-info.component.css']
})
export class ExperienceBasicInfoComponent implements OnInit {

  @Input() experienceForm: DVFormGroup;

  multiSelectSettings: IDropdownSettings = {
    singleSelection: false,
    idField: 'value',
    textField: 'display',
    allowSearchFilter: false,
  };
  experiences: any[];

  constructor(private experiencesService: ExperiencesService) { }

  ngOnInit() {
    this.loadLocalExps();
  }

  loadLocalExps() {
    this.experiencesService.getAllLocalExperience().subscribe(
      res => {
        this.experiences = (res.data.experiences as []).map((e: any) => {
          return {
            value: e.id,
            display: e.name
          };
        });
      }
    );
  }
}
